import React from 'react'
import { Link as TRLink } from '@planningcenter/tapestry-react'

export default React.forwardRef(function Link(props, ref) {
  return <TRLink color="primary" innerRef={ref} {...props} />
})
